import React from "react";
import { Composition } from "remotion";
import { HelloScene } from "./scenes/HelloScene";
import { SermonQuote } from "./scenes/SermonQuote";
import { VictoryWomen } from "./scenes/VictoryWomen";
import { HeavensWorship } from "./scenes/HeavensWorship";
import { SermonTitle } from "./scenes/SermonTitle";
import { VerseCard } from "./scenes/VerseCard";
import { Announcement } from "./scenes/Announcement";
import { LowerThird } from "./scenes/LowerThird";
import {
  HyperframesImages,
  calcHyperframesMetadata,
} from "./scenes/HyperframesImages";
import { ShortReel, calcShortReelMetadata } from "./scenes/ShortReel";

export const RemotionRoot: React.FC = () => {
  return (
    <>
      {/* Plain animated scene — proves the Remotion engine renders mp4. */}
      <Composition
        id="HelloScene"
        component={HelloScene}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          title: "Clipover Video Engine",
          subtitle: "Remotion ✓ · universal for all agents",
        }}
      />
      {/* Branded sermon-quote scene — Victory BA brand (PLU-496). */}
      <Composition
        id="SermonQuote"
        component={SermonQuote}
        durationInFrames={180}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          quote:
            "Но благодарение Богу, Который даёт нам победу через Господа нашего Иисуса Христа!",
          speaker: "Андрей Полищук",
          sermonTitle: "Победа во Христе",
          reference: "1 Коринфянам 15:57",
        }}
      />
      {/* Sub-brand: Victory Women — gold/serif/light-sky (PLU-497). */}
      <Composition
        id="VictoryWomen"
        component={VictoryWomen}
        durationInFrames={180}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          kicker: "МОЛИТВЕННО-ПРОРОЧЕСКАЯ ЖЕНСКАЯ КОНФЕРЕНЦИЯ",
          title: "НЕБО ВО МНЕ",
          subtitle: "— там, где говорит Бог",
          datePlace: "19–20 ИЮНЯ 2026 · БРАТИСЛАВА",
        }}
      />
      {/* Sub-brand: Heavens Worship — royal blue/mono/script (PLU-497). */}
      <Composition
        id="HeavensWorship"
        component={HeavensWorship}
        durationInFrames={180}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          title: "HEAVENS WORSHIP",
          scriptLine: "We Worship · He Works",
          subtitle: "VICTORY CHURCH BRATISLAVA",
        }}
      />
      {/* Sermon title (parent) — header strip + title. 16:9 + 9:16. */}
      <Composition id="SermonTitle" component={SermonTitle} durationInFrames={180} fps={30} width={1920} height={1080}
        defaultProps={{ pastor: "Андрей Полищук", dateLabel: "Вс, 7 июня 2026", title: "Я называю тебя", subtitle: "воскресное служение" }} />
      <Composition id="SermonTitleV" component={SermonTitle} durationInFrames={180} fps={30} width={1080} height={1920}
        defaultProps={{ pastor: "Андрей Полищук", dateLabel: "Вс, 7 июня 2026", title: "Я называю тебя", subtitle: "воскресное служение" }} />

      {/* Verse card. 16:9 + 9:16 (Reels). */}
      <Composition id="VerseCard" component={VerseCard} durationInFrames={180} fps={30} width={1920} height={1080}
        defaultProps={{ kicker: "Эдем", verse: "И Адам, и его жена были наги, но не испытывали стыда.", reference: "Бытие 2:25 НРП" }} />
      <Composition id="VerseCardV" component={VerseCard} durationInFrames={180} fps={30} width={1080} height={1920}
        defaultProps={{ kicker: "Эдем", verse: "И Адам, и его жена были наги, но не испытывали стыда.", reference: "Бытие 2:25 НРП" }} />

      {/* Announcement. 16:9 + 9:16. */}
      <Composition id="Announcement" component={Announcement} durationInFrames={180} fps={30} width={1920} height={1080}
        defaultProps={{ title: "Пасха", subtitle: "+ Водное крещение", date: "5 апреля", time: "11:00", place: "Братислава" }} />
      <Composition id="AnnouncementV" component={Announcement} durationInFrames={180} fps={30} width={1080} height={1920}
        defaultProps={{ title: "Пасха", subtitle: "+ Водное крещение", date: "5 апреля", time: "11:00", place: "Братислава" }} />

      {/* Lower-third (speaker plate) — overlay on horizontal video. */}
      <Composition id="LowerThird" component={LowerThird} durationInFrames={150} fps={30} width={1920} height={1080}
        defaultProps={{ name: "Андрей Полищук", role: "Пастор Victory Bratislava" }} />

      {/* Hyperframes → mp4: a sequence of pre-rendered 1920×1080 frame images,
          one Series.Sequence per frame, durations from HYPERFRAMES_META.
          Total duration is computed from props via calculateMetadata. */}
      <Composition
        id="Hyperframes"
        component={HyperframesImages}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{ fps: 30, frames: [] }}
        calculateMetadata={calcHyperframesMetadata}
      />

      {/* Брендовый шортс 9:16 (PLU-501 Шаг 2/3): синий фон + знак сверху +
          видео-блок 5:4 скруглённый + титры внутри (2-3 слова, акцент) +
          заголовок под видео. Длительность = длина клипа. */}
      <Composition
        id="ShortReel"
        component={ShortReel}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={{
          clipSrc: "clips/raw_4.mp4",
          title: "Кого ты видишь напротив",
          accentWord: "видишь",
          durationSec: 10,
          words: [],
        }}
        calculateMetadata={calcShortReelMetadata}
      />
    </>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
